var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.3078C6 11.9652 8.00971 13.7182 9.48087 14.7794C10.1469 15.2598 10.4799 15.5 11 15.5C11.5201 15.5 11.8531 15.2598 12.5191 14.7794C13.9903 13.7182 16 11.9653 16 10.3078C16 7.53888 13.2499 6.50511 11 8.64405C8.75008 6.50511 6 7.53888 6 10.3078Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.25C5.61522 1.25 1.25 5.61522 1.25 11C1.25 16.3848 5.61522 20.75 11 20.75C13.4221 20.75 15.639 19.866 17.3436 18.4043L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L18.4043 17.3436C19.866 15.639 20.75 13.4221 20.75 11C20.75 5.61522 16.3848 1.25 11 1.25ZM2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 13.2784 18.3274 15.3399 16.8336 16.8336C15.3399 18.3274 13.2784 19.25 11 19.25C6.44365 19.25 2.75 15.5563 2.75 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCheck);
export default __webpack_public_path__ + "static/media/heart-check.897fa8c14918bb1881ff03601889b50e.svg";
export { ForwardRef as ReactComponent };